import { Injectable, inject } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {DialogMessageComponent} from "../components/dialog-message/dialog-message.component";

@Injectable({
  providedIn: 'root'
})
export class MessageDialogService {
  private dialog = inject(MatDialog);


  /**
   * Dialogue simple avec un seul bouton (OK / Continuer)
   */
  openMessage(
    titleKey: string,
    descriptionKey: string | string[],
    actionBtnKey = 'ok',
    type: 'info' | 'warning' | 'error' = 'info',
    cancelBtnKey?: string
  ) {
    return this.dialog.open(DialogMessageComponent, {
      width: '400px',
      data: {titleKey, descriptionKey, actionBtnKey, cancelBtnKey, type}
    }).afterClosed();
  }


  /**
   * Dialogue de confirmation avec 2 boutons (Oui / Non)
   */
  openConfirm(titleKey: string, descriptionKey: string, confirmKey = 'yes', cancelKey = 'no') {
    return this.dialog.open(DialogMessageComponent, {
      width: '400px',
      data: {
        titleKey,
        descriptionKey,
        actionBtnKey: confirmKey,
        cancelBtnKey: cancelKey,
        type: 'confirm'
      }
    }).afterClosed();
  }

}
